/**
 * W5 — render a figure only when the API measured it.
 *
 * The admin AI/ML routes now answer null (with `status: "unknown"`) where
 * they used to invent numbers. `value ?? 0` turned that null back into a
 * confident "0%". These helpers make the view say so instead.
 */

export const LOADING_TEXT = '—'
export const NOT_MEASURED_TEXT = 'Not measured'

export function isMeasured(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value)
}

export function formatMeasured(
  value: number | null | undefined,
  opts: { loading?: boolean; suffix?: string; format?: (n: number) => string } = {},
): string {
  if (opts.loading) return LOADING_TEXT
  if (!isMeasured(value)) return NOT_MEASURED_TEXT
  const text = opts.format ? opts.format(value) : String(value)
  return `${text}${opts.suffix ?? ''}`
}
